import BigNumber from 'bignumber.js';

import { BrnVault } from 'types/contracts';
import { IGetBrnVaultPoolInfoOutput } from './types';

const formatToUserInfo = ({
  token,
  allocPoint,
  lastRewardBlock,
  accRewardPerShare,
  lockPeriod,
}: Awaited<
  ReturnType<ReturnType<BrnVault['methods']['poolInfos']>['call']>
>): IGetBrnVaultPoolInfoOutput => ({
  stakedTokenAddress: token,
  allocationPoint: +allocPoint,
  lastRewardBlock: +lastRewardBlock,
  accRewardPerShare: new BigNumber(accRewardPerShare),
  // Convert lockPeriod from seconds to milliseconds
  lockingPeriodMs: +lockPeriod * 1000,
});

export default formatToUserInfo;
